
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6ab2e7","d":"M0 0h15v10H0z"}}),_c('path',{attrs:{"fill":"#12ad2b","d":"M0 5h15v5H0z"}}),_c('path',{attrs:{"d":"M0 0v10l4.33-2.5L8.66 5 4.33 2.5 0 0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.314 3.75l.31.955H4.63l-.813.59.31.955-.812-.59-.812.59.31-.955L2 4.705h1.004l.31-.955z","fill":"#d7141a"}})])
          )
        }
      }
    